export default {
  batchPrintingVerifications: [],
  batchPrintingVerification: undefined,
};
